import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';
import Footer from '../Footer/Footer';
import React from 'react';

import joinus from '../../assets/img/joinus.jpg';
import './Launcher.scss';

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

export default function Launcher() {
  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="team"
    >
      <Helmet>
        <title>Launcher - DuskBreakers</title>
        <meta
          name="description"
          content="Launch Web3 games on Windows with the DuskBreaker Launcher"
        />
      </Helmet>

      <section className="has-bg">
        <div className="container launcher-container">
          <div className="row d-flex justify-content-center">
            <div className="col">
              <LazyLoadImage
                className="rounded img-fluid"
                alt="The Corrupted"
                src={joinus}
                effect="opacity"
              />
            </div>
          </div>

          <div className="row d-flex justify-content-center">
            <div className="col-lg-8">
              <div className="pt-5">
                <h2 className="text-center">The DuskBreakers Launcher</h2>
                <p>
                  The DuskBreakers Launcher is a Web3 game update system that downloads, launches,
                  and keeps games up to date for native EXE play of our games. It is similar to
                  other game launcher systems that you are familiar with that keep your games up to
                  date and secure. The main difference is that our system is Web3 native and we have
                  focused on industry leading ways to keep your Wallet secure!
                </p>

                <div className="pt-4 launcher-download-desktop">
                  <a
                    className="btn btn-primary me-4"
                    href="https://duskbreakers.gg/launcherapi/DuskBreakers.msi"
                    role="button"
                  >
                    Download Now
                  </a>
                </div>
                <div className="launcher-download-mobile">
                  Our launcher is only available on Windows & MacOS
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="is-bg stripes" />
      </section>

      <section>
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-8">
              <div className="accordion accordion-dark mb-4" id="launcherfaq">
                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      How will this improve my gameplay experience of DuskBreakers games?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        For our DuskBreakers games, we launched them as Web experiences to provide
                        the broadest reach in the most secure manner possible. However, gameplay
                        performance did suffer as WebGL gaming still is not as performant as native
                        games. The DuskBreakers Launcher removes this bottleneck, allowing you to
                        play with maximum performance and security.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      How is it different from other Web3/Crypto Game Launchers?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        We have created a system that allows for interaction with Web3 contracts
                        through standard and trusted Metamask interactions. Our systems never
                        receive your private key. When you use our launcher, a Web3 page appears for
                        you to sign in in the exact same manner as you would when interacting on the
                        public web. We never ask for your passphrase, we never receive it, and we
                        never store it. The interaction power is owned and controlled by you, and
                        you never delegate any authority to us at all.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Why is this style of interaction for Web3 important?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        We are committed to maximizing the user&apos;s security. By never storing
                        sensitive information inside of any of our systems, you can be assured that
                        you have full control over your crypto account. If we need any data, for
                        example what NFTs you own, you are in control of giving us that data. We
                        only ever deal with public data already available on the blockchain so your
                        security is maintained.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      Will you ever ask for my passphrase?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        No! No DuskBreakers game will EVER ask for your Wallet passphrase. Never
                        enter your passphrase into any executable or website. We never want to have
                        sensitive data inside of any of our systems. If you see something asking for
                        a passphrase, it will never be us asking for it.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      Do I have to be a Breaker holder to use the Launcher?
                    </button>
                  </h2>
                  <div
                    id="collapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFive"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        Nope! Any Wallet can be connected to the launcher. Having a breaker is not
                        required. Of course for holders, you can select your breaker to receive the
                        in-game benefits in the same way you could on the web versions of the game.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingSix">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                      How should this look to me as a user?
                    </button>
                  </h2>
                  <div
                    id="collapseSix"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingSix"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        When you download the launcher and run the executable, a cryptographically
                        signed MSI installer will appear. After installation of the launcher, you
                        can connect your Wallet by clicking on the account connection button which
                        will pop up a webpage. There, you can use your Metamask wallet to interact
                        with the webpage and grant access to your account. Then, you can download
                        and launch the executable for our games. The account you connect with the
                        launcher is the account you will be using in the game.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingSeven">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSeven"
                      aria-expanded="false"
                      aria-controls="collapseSeven"
                    >
                      Is the Launcher required to play our games?
                    </button>
                  </h2>
                  <div
                    id="collapseSeven"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingSeven"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        Yes. In order to keep your account secure, you have to use this launcher
                        system so we can safely get any needed Wallet information to the game. Our
                        games will not work if the launcher is not running.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingEight">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseEight"
                      aria-expanded="false"
                      aria-controls="collapseEight"
                    >
                      How do I switch accounts?
                    </button>
                  </h2>
                  <div
                    id="collapseEight"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingEight"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        By clicking the Account button in the launcher, you can sign into other
                        Wallet accounts you own via the logout button on the displayed page.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingNine">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseNine"
                      aria-expanded="false"
                      aria-controls="collapseNine"
                    >
                      What if the webpage pops up in the wrong web browser?
                    </button>
                  </h2>
                  <div
                    id="collapseNine"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingNine"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        We use the default Windows browser to direct users to the sign in systems.
                        If that is not the correct browser for your MetaMask wallet, copy and paste
                        the URL in your preferred Web3 connected browser and everything will work as
                        expected.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}

                {/* ======================== Accordion OPEN */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTen">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTen"
                      aria-expanded="false"
                      aria-controls="collapseTen"
                    >
                      How does this system work on a technical level?
                    </button>
                  </h2>
                  <div
                    id="collapseTen"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTen"
                    data-bs-parent="#launcherfaq"
                  >
                    <div className="accordion-body">
                      <p>
                        When the launcher is running, a small webserver runs on your machine to
                        display our Web3 account connection system. This allows you to perform
                        standard Web3 interactions controlled entirely by you. After any needed
                        interactions like connecting your account happens on the webpage, the page
                        informs the launcher of the public, on-chain metadata you require. Then the
                        launcher informs the game of this public metadata. All interactions are with
                        public data only; we never see, touch, or store any secrets.
                      </p>
                    </div>
                  </div>
                </div>
                {/* ======================== Accordion CLOSE */}
              </div>

              <p className="text-muted m-0 mb-2">
                MD5 Hash of Launcher MSI: b4b1319f1319927916bb550a1a0287e4
              </p>
              <p className="text-muted m-0 mb-2">
                MD5 Hash of Classic Game exe: 15ccb9bb65c72fecc4b50305fc426514
              </p>
              <p className="text-muted m-0">
                MD5 Hash of Beast Battler exe: 15ccb9bb65c72fecc4b50305fc426514
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
